import { http } from './httpClient';

export function getWebCatalog(businessId, { signal } = {}) {
    return http.get(`/api/public/catalog/${businessId}`, undefined, { signal });
}

// Fallback: branchId orqali olish
export function getWebCatalogByBranch(branchId, { signal } = {}) {
    return http.get(`/api/public/catalog/by-branch/${branchId}`, undefined, { signal });
}
